import { render } from "./CrmListViewImportModalFormItems.vue?vue&type=template&id=c2255744&scoped=true"
import script from "./CrmListViewImportModalFormItems.vue?vue&type=script&lang=js"
export * from "./CrmListViewImportModalFormItems.vue?vue&type=script&lang=js"

import "./CrmListViewImportModalFormItems.vue?vue&type=style&index=0&id=c2255744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2255744"]])

export default __exports__